<template>
  <transition name="slide-y">
    <v-snackbar
      v-model="alertaEquipoUso.estatus"
      right
      top
      vertical
      color="amber darken-4"
      class="text-center mb-0 pt-2"
      :timeout="15000"
    >
      <v-card class="elevation-0 transparent textoPoppins white--text">
        <v-card-title class="pb-2">
          <v-icon color="white" large left>mdi-alert-octagon</v-icon>
          <span class="text-h6 font-weight-bold">ALERTA DE SISTEMA</span>
        </v-card-title>
        <v-divider dark class="mb-2"></v-divider>
        <v-card-text class="white--text text-left pt-0">
          <div class="mb-2 font-weight-bold">EQUIPO: {{ alertaEquipoUso.info ? alertaEquipoUso.info.id_equipo : 'N/A' }}</div>
          <div style="white-space: pre-line" class="text-body-2 font-italic border-left-alert pl-2">
            "{{ alertaEquipoUso.info ? alertaEquipoUso.info.motivo : 'Sin motivo especificado' }}"
          </div>
          <div class="mt-3 text-caption text-uppercase">Este reporte ha sido enviado a tu jefe directo.</div>
        </v-card-text>
      </v-card>
      
      <template v-slot:action="{ attrs }">
        <v-btn
          dark
          text
          v-bind="attrs"
          @click="alertaEquipoUso.estatus = false"
          small
        >
          Cerrar
        </v-btn>
      </template>
    </v-snackbar>
  </transition>
</template>

<script>
export default {
  props: {
    alertaEquipoUso: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
.textoPoppins {
  font-family: 'Poppins', sans-serif !important;
}
.border-left-alert {
  border-left: 3px solid rgba(255, 255, 255, 0.5);
}
.slide-y-enter-active, .slide-y-leave-active {
  transition: transform 0.5s ease;
}
.slide-y-enter, .slide-y-leave-to {
  transform: translateY(-100%);
}
</style>
